import { render, staticRenderFns } from "./projectFileUpload.vue?vue&type=template&id=f621dd5a&scoped=true"
import script from "./projectFileUpload.vue?vue&type=script&lang=js"
export * from "./projectFileUpload.vue?vue&type=script&lang=js"
import style0 from "./projectFileUpload.vue?vue&type=style&index=0&id=f621dd5a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f621dd5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f621dd5a')) {
      api.createRecord('f621dd5a', component.options)
    } else {
      api.reload('f621dd5a', component.options)
    }
    module.hot.accept("./projectFileUpload.vue?vue&type=template&id=f621dd5a&scoped=true", function () {
      api.rerender('f621dd5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/file/projectFileUpload.vue"
export default component.exports